const GENRE_LABEL_KEYS = {
  'Sci-Fi': 'sciFi',
  Romance: 'romance',
  Poetry: 'poetry',
  Mystery: 'mystery',
  Fantasy: 'fantasy',
};

function translateWithDefault(t, key, defaultValue, options = {}) {
  if (typeof t !== 'function') return defaultValue;
  return t(key, {
    defaultValue,
    ...options,
  });
}

export function localizeGenreLabel(genre, t) {
  const key = GENRE_LABEL_KEYS[genre];
  if (!key) return genre;
  return translateWithDefault(t, `challengesRuntime.genres.${key}`, genre);
}

export function localizeChallenge(challenge, t) {
  if (!challenge) return challenge;

  return {
    ...challenge,
    genreKey: challenge.genre,
    title: translateWithDefault(
      t,
      `challengesRuntime.liveChallenges.${challenge.slug}.title`,
      challenge.title,
    ),
    description: translateWithDefault(
      t,
      `challengesRuntime.liveChallenges.${challenge.slug}.description`,
      challenge.description,
    ),
    genre: localizeGenreLabel(challenge.genre, t),
    rewardLabels: (challenge.rewardLabels || []).map((reward, index) =>
      translateWithDefault(
        t,
        `challengesRuntime.liveChallenges.${challenge.slug}.rewardLabels.${index}`,
        reward,
      )
    ),
  };
}
